window.Products.Accessory.SnapbackWithPrintedPatch = function() {};
window.Products.Accessory.SnapbackWithPrintedPatch.inherits(window.Products.Accessory.Accessory);